<template>
  <Toast/>
  <InformationBasic :isDataLoading="isDataLoading" :numeroFiche="numeroFiche" :nom="nom"
                    :classeAfficher="classeAfficher" :raisonEtre="raisonEtre"
                    :majeureInvestigationLectureColonne="majeureInvestigationLectureColonne"
                    :majeureInvestigationEcritureColonne="majeureInvestigationEcritureColonne"
                    :mineureInvestigationLectureColonne="mineureInvestigationLectureColonne"
                    :mineureInvestigationEcritureColonne="mineureInvestigationEcritureColonne"
                    :mineureInvestigation="mineureInvestigation" :majeureInvestigation="majeureInvestigation"
                    :mineureInvestigationAfficher="mineureInvestigationAfficher"
                    :majeureInvestigationAfficher="majeureInvestigationAfficher"/>
  <InformationSupplementaire :isDataLoading="isDataLoading" :nomReference="nomReference"
                             :numeroEntrepriseQuebec="numeroEntrepriseQuebec" :siteAfficher="siteAfficher"
                             :prenomReference="prenomReference" :reference="reference"
                             :creerLe="creerLe" :region="region" :confidentialiteAfficher="confidentialiteAfficher"
                             :creerParDescription="creerParDescription" :centreRegionalRDD="centreRegionalRDD"
                             :codeCompteRDD="codeCompteRDD"
                             :indicateurRDD="indicateurRDD" :raisonDesactivationRDD="raisonDesactivationRDD"
                             :territoireRDD="territoireRDD" :statutExclusionRDD="statutExclusionRDD"
                             :dateDesactivationRDD="dateDesactivationRDD" :actifRDD="actifRDD"
                             :dateFinRDD="dateFinRDD"/>
  <ButtonBar :actionAccesDecision="actionAccesDecision" :isSociete="true" @auditModifications="auditModifications"
             @fermer="fermer" @auditAcces="auditAcces" @modifier="modifier" @imprimerSociete="imprimerSociete"/>
  <LiaisonsModule :isModifier="false" :genre="'SO'" ref="liaisonModule"/>
  <DialogConfirmation ref="dialogConfirmation"/>
</template>

<script>
import ButtonBar from '../../components/Commun/ButtonBarConsulter.vue'
import InformationBasic from '../../components/societe/Consulter/InformationBasic.vue'
import InformationSupplementaire from '../../components/societe/Consulter/InformationSupplementaire.vue'
import LiaisonsModule from '../../components/Commun/LiaisonsModule.vue'
import {mapGetters} from "vuex";
import axios from "axios";
import DialogConfirmation from "@/components/Commun/DialogConfirmation.vue";

export default {
  name: "SocieteConsulter",
  components: {
    DialogConfirmation,
    ButtonBar,
    InformationBasic,
    InformationSupplementaire,
    LiaisonsModule,
  },
  beforeMount() {
    this.$root.$refs.breadcrumbComp.source.nom = 'societe';
    this.$root.$refs.breadcrumbComp.source.genre = 'SO';
  },
  mounted() {
    this.isDataLoading = true;
    this.$root.$refs.breadcrumbComp.ajout("Consulter Société");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.getSociete();
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      actionAccesDecision: "societe/actionAccesDecision"
    })
  },
  data() {
    return {
      isDataLoading: false,

      actifRDD: null,
      classeAfficher: null,
      centreRegionalRDD: null,
      codeCompteRDD: null,
      confidentialiteAfficher: null,
      creerLe: null,
      creerParDescription: null,
      dateDesactivationRDD: null,
      dateFinRDD: null,
      indicateurRDD: null,
      mineureInvestigation: null,
      majeureInvestigation: null,
      mineureInvestigationLectureColonne: null,
      majeureInvestigationLectureColonne: null,
      mineureInvestigationEcritureColonne: null,
      majeureInvestigationEcritureColonne: null,
      mineureInvestigationAfficher: null,
      majeureInvestigationAfficher: null,
      nom: null,
      nomReference: null,
      numeroEntrepriseQuebec: null,
      numeroFiche: null,
      prenomReference: null,
      raisonDesactivationRDD: null,
      raisonEtre: null,
      reference: null,
      region: null,
      siteAfficher: null,
      statutExclusionRDD: null,
      territoireRDD: null,
    };
  },
  methods: {
    assignerSociete(res) {
      if (res.data.entite.actif) {
        this.actifRDD = "Oui";
      } else {
        this.actifRDD = "Non";
      }
      this.classeAfficher = res.data.entite.classeAfficher;
      this.confidentialiteAfficher = res.data.entite.confidentialiteAfficher;
      this.creerLe = res.data.entite.creerLe;
      this.creerParDescription = res.data.entite.creerParDescription;
      this.mineureInvestigation = res.data.entite.mineureInvestigation;
      this.majeureInvestigation = res.data.entite.majeureInvestigation;
      this.mineureInvestigationAfficher = res.data.entite.mineureInvestigationAfficher;
      this.majeureInvestigationAfficher = res.data.entite.majeureInvestigationAfficher;
      this.nom = res.data.entite.nom;
      this.nomReference = res.data.entite.nomReference;
      this.numeroEntrepriseQuebec = res.data.entite.numeroEntrepriseQuebec;
      this.numeroFiche = res.data.entite.numeroFiche;
      this.prenomReference = res.data.entite.prenomReference;
      this.raisonEtre = res.data.entite.raisonEtre;
      this.reference = res.data.entite.reference;
      this.region = res.data.entite.region;
      this.siteAfficher = res.data.entite.siteAfficher;
      this.indicateurRDD = res.data.entite.indicateurRDD;

      if (res.data.entite.detaillantInfos !== null) {
        this.centreRegionalRDD = res.data.entite.detaillantInfos.numeroCentreRegional + ' ' +
            res.data.entite.detaillantInfos.nomCentreRegional;
        this.codeCompteRDD = res.data.entite.detaillantInfos.codeCompte;
        this.dateFinRDD = res.data.entite.detaillantInfos.dateFinOperation;
        this.dateDesactivationRDD = res.data.entite.detaillantInfos.inactivationDate;
        this.raisonDesactivationRDD = res.data.entite.detaillantInfos.raisonInactivation;
        this.statutExclusionRDD = res.data.entite.detaillantInfos.statutExclusion;
        this.territoireRDD = res.data.entite.detaillantInfos.nomTerritoire;
      }
      if(res.data.messages.length > 0){
        this.$root.$refs.messagesComp.messagesList = res.data.messages
      }

      this.mineureInvestigationLectureColonne =
          res.data.entiteDecision.mineureInvestigation.lectureAcces;
      this.majeureInvestigationLectureColonne =
          res.data.entiteDecision.majeureInvestigation.lectureAcces;
      this.mineureInvestigationEcritureColonne =
          res.data.entiteDecision.mineureInvestigation.ecritureAcces;
      this.majeureInvestigationEcritureColonne =
          res.data.entiteDecision.majeureInvestigation.ecritureAcces;
    },
    getSociete() {
      this.$store
          .dispatch("societe/consulterAction", {
            cle: this.$route.params.cle,
            site: this.$route.params.site,
            isDetaillant: this.$route.params.isDetaillant,
          })
          .then((res) => {
            this.assignerSociete(res);
            this.isDataLoading = false;
          });
    },
    auditAcces() {
      this.$router.push({
        name: "SocieteAuditAcces",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site,
          isDetaillant: this.$route.params.isDetaillant
        },
      });
    },
    auditModifications() {
      this.$router.push({
        name: "SocieteAuditModifications",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    modifier() {
      this.$router.push({
        name: "societeModifier",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site,
          isDetaillant: this.$route.params.isDetaillant,
        },
      });
    },
    imprimerSociete() {
      this.$router.push({name: 'societeRapportCDX0003',
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        }});
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
  watch: {
    '$route.params': function (nouveaux, anciens) {
      if ((this.$route.name === "societeConsulter")
          && nouveaux.cle
          && (nouveaux.cle !== anciens.cle)) {
        location.reload()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.liaisonModule?.changesTelephoneEtCourriel?.()) {
      return this.$refs.dialogConfirmation.confirmer(next, 'a', 'b');
    }
    else{
      return next();
    }
  }
};
</script>
